import { html, LitElement } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import AabIcon from '@aab/sc-aab-icon/src/AabIcon';
import {
  sy_notification_error_16 as iconError,
  sy_notification_error_outlined_16 as iconErrorOutlined,
  sy_notification_info_16 as iconInfo,
  sy_notification_info_outlined_16 as iconInfoOutlined,
  sy_notification_verified_16 as iconVerified,
  sy_notification_verified_outlined_16 as iconVerifiedOutlined,
  sy_notification_warning_16 as iconWarning,
  sy_notification_warning_outlined_16 as iconWarningOutlined,
} from '@aab/sc-aab-icon-set';
import {
  info400, n400, negative400, positive400, warning400,
} from '@aab/sc-styles-colors';
import Styles from './styles.scss';

export default class AabInputmessage extends ScopedElementsMixin(LitElement) {
  constructor() {
    super();
    // Initialize LitElement properties here
    this.type = 'info';
    this.message = '';
  }

  static get properties() {
    return {
      type: { type: String, converter: (value) => (AabInputmessage.types.some((t) => t === value) ? value : 'info') },
      message: { type: String },
      background: { type: Boolean },
      icon: { type: Boolean },
      textNowrap: { type: Boolean, attribute: 'text-nowrap' },
    };
  }

  static get scopedElements() {
    return {
      'aab-icon': AabIcon,
    };
  }

  static get styles() {
    return [Styles];
  }

  static get types() {
    return ['info', 'inactive', 'negative', 'positive', 'warning'];
  }

  static getIconInfo(type, background) {
    switch (type) {
      case 'inactive':
        return { svg: background ? iconVerifiedOutlined : iconVerified, color: n400 };
      case 'negative':
        return { svg: background ? iconErrorOutlined : iconError, color: negative400 };
      case 'positive':
        return { svg: background ? iconVerifiedOutlined : iconVerified, color: positive400 };
      case 'warning':
        return { svg: background ? iconWarningOutlined : iconWarning, color: warning400 };
      case 'info':
      default:
        return { svg: background ? iconInfoOutlined : iconInfo, color: info400 };
    }
  }

  renderIcon() {
    const icon = AabInputmessage.getIconInfo(this.type, this.background);
    return html`<div class="icon-wrapper mr-1"><aab-icon svg=${icon.svg} color=${icon.color} size="2"></aab-icon></div>`;
  }

  render() {
    return html`
      <div class="d-inline-block text-small ${this.type} ${this.background ? 'background rounded-2 spy-1 px-1' : ''}" ?hidden=${this.message === ''}>
        <div class="d-flex align-items-start ${this.textNowrap ? 'text-nowrap' : ''}">
          ${this.icon ? this.renderIcon() : ''}
          <span class="text-wrapper">${this.message}</span>
        </div>
      </div>
    `;
  }
}
